var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"text-right pr-11",attrs:{"col":"12","xl":"8","lg":"8"}},[_c('v-btn',{attrs:{"color":"primary","to":{ name: 'CreateProject' }}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v(" add ")]),_vm._v(" Create ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }